<template>
    <b-modal v-if="student" id="quest-modal" size="lg" header-class="p-4 bg-light border-0" hide-footer centered @hidden="onClose" @show="loadQuestions">
        <template #modal-title>
            <div class="d-flex align-items-center ">
                <h4 class="font-size-18 font-weight-semibold mb-0">Questionnaire</h4>
                <div class="ml-4">
                    <div class="font-size-13 text-primary">Pour {{ student.prenom }} {{ student.nom }}</div>
                    <div class="font-size-11 text-muted">{{ student.filiere }}</div>
                </div>
            </div>
        </template>

        <div class="position-relative p-3" :class="{ locked: student.date }" style="min-height: 200px">
            <Loader :loading="loading" />

            <div class="mb-3" v-for="question in questions" :key="question.id">
                <template v-if="condition(question.type, question.condition)">
                    <p class="text-primary" v-if="question.text">{{ question.text }}</p>
                    <template v-if="['radio', 'checkbox'].includes(question.type) && question.options">
                        <component :is="`b-form-${question.type}-group`" v-model="responses[question.id]" stacked :options="JSON.parse(question.options)"></component>
                    </template>
                    <multiselect v-if="question.type == 'dropdown' && question.options" v-model="responses[question.id]" :show-labels="false" placeholder="" :options="JSON.parse(question.options)">
                        <template #noOptions>Aucun élément trouvé</template>
                    </multiselect>
                    <b-input v-if="question.type == 'text'" v-model="responses[question.id]" />
                    <hr v-if="question.type == 'divider'" class="my-5" />
                </template>
            </div>
        </div>

        <div class="d-flex bg-white align-items-center justify-content-end mt-3 pb-2 px-4">
            <b-button class="ml-2 px-3" pill @click="$bvModal.hide('quest-modal')">{{ student.date ? "Fermer" : "Annuler" }}</b-button>
            <q-button v-if="!student.date" class="ml-2 px-3" pill variant="primary" :loading="submitLoading" @click="submitChanged">Valider le Questionnaire</q-button>
        </div>
    </b-modal>
</template>

<script>
    import Loader from "./ui/loader";

    export default {
        components: { Loader },
        props: {
            student: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => ({
            questions: [],
            responses: {},
            loading: false,
            submitLoading: false
        }),
        methods: {
            async submitChanged() {
                try {
                    this.submitLoading = true;
                    const resp = await this.$axios.post("/surveys", {
                        stagiaireFiliere: this.student.stagiaireFiliere,
                        responses: this.responses
                    });
                    this.$emit("submited", resp.data);
                    this.$bvModal.hide("quest-modal");
                } finally {
                    this.submitLoading = false;
                }
            },
            async loadQuestions() {
                this.loading = true;
                const resp = await this.$axios.get(`/questions/${this.student.stagiaireFiliere}`);
                this.questions = resp.questions;
                this.responses = resp.responses;
                this.loading = false;
            },
            condition(type, condition) {
                if (!condition) return true;
                const parts = condition.split("==").map(item => item.trim());
                if (type == "checkbox") return this.responses[parts[0]]?.[0] == parts[1];
                return this.responses[parts[0]] == parts[1];
            },
            onClose() {
                this.questions = [];
                this.responses = {};
            }
        }
    };
</script>

<style lang="scss" scoped>
    .locked {
        pointer-events: none;
    }
</style>
